import { FedopsLogger } from '@wix/fedops-logger';
import { win } from '../win';

export const interactionEndedCrossEnv = <InteractionName extends string>({
  logger,
  interactionName,
  startTime,
  endTime,
}: {
  logger: FedopsLogger<InteractionName>;
  interactionName: InteractionName;
  startTime: number;
  endTime: number;
}): void => {
  try {
    const appName: string = logger.getAppName();

    const fedops: {
      apps: {
        [appName: string]: {
          interactions: {
            [interactionName: string]: {
              timestamp: number;
            };
          };
        };
      };
    } = (win as any).fedops;

    if (!fedops?.apps || !fedops.apps.hasOwnProperty(appName)) {
      logger.interactionEnded(interactionName);
      return;
    }

    const appEntry = fedops.apps[appName];

    if (
      appEntry.interactions?.hasOwnProperty(interactionName) &&
      Number.isInteger(appEntry.interactions[interactionName].timestamp)
    ) {
      logger.interactionEnded(interactionName);
      return;
    }

    appEntry.interactions = appEntry.interactions || {};
    appEntry.interactions[interactionName] = {
      timestamp: startTime,
    };

    logger.interactionEnded(interactionName, { timeOverride: endTime });
  } catch (error) {
    console.error(`interactionEndedCrossEnv failure`, error);
  }
};
